import React, { useState } from 'react';
import { FaBars } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { useHoverPreload } from '../hooks/useRoutePreloader';

const menuLinks = [
  { to: '/#hero', label: 'Inicio' },
  { to: '/#nosotros', label: 'Nosotros' },
  { to: '/destinos', label: 'Destinos' },
  // { to: '/cruceros', label: 'Cruceros' }, // Ocultado temporalmente
  { to: '/asistencia', label: 'Asistencia' },
  { to: '/#contacto', label: 'Contacto' },
];

export default function Header() {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const location = useLocation();
  const { preloadOnHover } = useHoverPreload();

  const handleClick = (to) => {
    const [pathname, hash] = to.split('#');
    if (pathname !== location.pathname) {
      window.location.href = to; // redirige y scroll automático gracias al hook
    } else if (hash) {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMenuAbierto(false);
  };

  return (
    <>
      {/* barra superior */}
      <div className="bg-[#B49A56] text-white text-sm px-4 py-2">
        <div className="flex flex-col md:flex-row justify-between items-center max-w-7xl mx-auto gap-2 md:gap-0">
          <div className="hidden md:flex flex-wrap items-center gap-4">
            <span className="flex items-center gap-1">
              <i className="fab fa-whatsapp" />
              <a href="https://wa.me/5492616388375" target="_blank" rel="noopener noreferrer" className="hover:underline">
                +54 9 261 638-8375
              </a>
            </span>
            <span className="flex items-center gap-1">
              <i className="fa fa-envelope" aria-hidden="true" />
              <a href="mailto:belutours@gmail.com" className="hover:underline">belutours@gmail.com</a>
            </span>
          </div>
          <div className="flex justify-center md:justify-end items-center gap-4 w-full md:w-auto">
            <a href="https://facebook.com/belutours" target="_blank" rel="noopener noreferrer" title="Facebook"><i className="fab fa-facebook-f" /></a>
            <a href="https://instagram.com/belutours" target="_blank" rel="noopener noreferrer" title="Instagram"><i className="fab fa-instagram" /></a>
            <a href="https://www.tiktok.com/@belu.tours" target="_blank" rel="noopener noreferrer" title="TikTok"><i className="fab fa-tiktok" /></a>
          </div>
        </div>
      </div>

      {/* logo y navegación */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="flex justify-between items-center px-4 py-3 md:px-8">
          <div className="flex justify-center items-center w-full">
            <img src={`${process.env.PUBLIC_URL}/assets/logo-belutours-header.webp`} alt="Belu Tours logo"
              className="w-24 h-24 sm:w-28 md:w-32 lg:w-36 object-contain" />
          </div>

          <button className="md:hidden text-[#B49A56]" onClick={() => setMenuAbierto(!menuAbierto)} aria-label="Abrir menú">
            <FaBars size={22} />
          </button>

          {/* menú desktop */}
          <nav className="hidden md:flex space-x-6 text-[#B49A56] font-medium">
            {menuLinks.map((link, i) => (
              <button 
                key={i} 
                onClick={() => handleClick(link.to)} 
                onMouseEnter={() => preloadOnHover(link.to)}
                className="hover:text-[#8c723d] transition-colors duration-200"
              >
                {link.label}
              </button>
            ))}
          </nav>
        </div>

        {/* menú mobile */}
        {menuAbierto && (
          <div className="md:hidden flex flex-col items-center gap-3 pb-4 text-[#B49A56] font-medium bg-white">
            {menuLinks.map((link, i) => (
              <button 
                key={i} 
                onClick={() => handleClick(link.to)} 
                onMouseEnter={() => preloadOnHover(link.to)}
                className="hover:text-[#8c723d] transition-colors duration-200"
              >
                {link.label}
              </button>
            ))}
          </div>
        )}
      </header>
    </>
  );
}
